import './App.scss';
import { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { ConfirmModal } from './components/ui';
import { AppProvider } from './context/AppContext';
import { PageHeaderProvider } from './context/PageHeaderContext';
import AppRoutes from './routes/AppRoutes';
import PageTracker from './routes/PageTracker';
import { QUOTA_EXCEEDED_EVENT, QUOTA_EXCEEDED_MESSAGE } from './services/apiClient';

function App() {
  const [quotaModalOpen, setQuotaModalOpen] = useState(false);
  const [quotaModalIsTrialEnded, setQuotaModalIsTrialEnded] = useState(false);
  const [quotaModalContent, setQuotaModalContent] = useState({
    title: '토큰 부족',
    message: QUOTA_EXCEEDED_MESSAGE,
  });

  useEffect(() => {
    const handleQuotaExceeded = (event) => {
      const trialEnded = Boolean(event?.detail?.trialEnded);
      setQuotaModalIsTrialEnded(trialEnded);
      setQuotaModalContent({
        title: trialEnded ? '무료 체험 종료 안내' : '토큰 부족',
        message: trialEnded
          ? '이용 가능한 토큰이 모두 소진되었습니다.\n추가적인 이용은 문의 부탁드립니다.'
          : event?.detail?.message || QUOTA_EXCEEDED_MESSAGE,
      });
      setQuotaModalOpen(true);
    };

    window.addEventListener(QUOTA_EXCEEDED_EVENT, handleQuotaExceeded);
    return () => window.removeEventListener(QUOTA_EXCEEDED_EVENT, handleQuotaExceeded);
  }, []);

  return (
    <AppProvider>
      <Router>
        <PageTracker />
        <PageHeaderProvider>
          <div className="App">
            <AppRoutes />
          </div>
          <ConfirmModal
            isOpen={quotaModalOpen}
            type="warning"
            title={quotaModalContent.title}
            message={quotaModalContent.message}
            subMessage=""
            confirmText={quotaModalIsTrialEnded ? '이용 문의' : '확인'}
            showCancel={quotaModalIsTrialEnded}
            cancelText="취소"
            align={quotaModalIsTrialEnded ? 'dialog' : undefined}
            className={quotaModalIsTrialEnded ? 'trial-ended-confirm-modal' : ''}
            onConfirm={() => {
              if (quotaModalIsTrialEnded) {
                setQuotaModalOpen(false);
                window.location.href = '/inquiry';
                return;
              }
              setQuotaModalOpen(false);
            }}
            onCancel={() => setQuotaModalOpen(false)}
          />
        </PageHeaderProvider>
      </Router>
    </AppProvider>
  );
}

export default App;
